export const CustomerDemoData = [
    {
        id: 11111,
        role: 'customer',
        firstName: 'Yeasin',
        lastName: 'Arafat',
        fullName: 'Yeasin Arafat',
        organization: 'Bikiran',
        primaryPhone: '01795617763',
        primaryEmail: 'yeasinn2002@gmail.com',
        photoUrl: 'https://storage.googleapis.com/miracle-bucket-23/profile_images/profile.jpg',
        primaryAddress: '',
        status: 'active',
        timeCreated: 1701444270,
        tfaEnabled: false,
        subscriptions: [
            {
                id: 70,
                subscriptionName: 'HRCT - Purchase',
                logoUrl: 'https://miracleadvance.com/wp-content/uploads/2023/09/HRCT.svg'
            },
            {
                id: 71,
                subscriptionName: 'Digital Experience Checkup -ABC',
                logoUrl: 'https://miracleadvance.com/wp-content/uploads/2023/09/DEC-1.svg'
            }
        ],
        demo: true
    },
    {
        id: 22222,
        role: 'customer',
        firstName: 'Noman',
        lastName: 'Gazi',
        fullName: 'Noman Gazi',
        organization: 'Bikiran.com',
        primaryPhone: '01726387662',
        primaryEmail: 'numan.islam61@gmail.com',
        photoUrl: 'https://storage.googleapis.com/miracle-bucket-23/profile_images/Noman Gazi.jpeg',
        primaryAddress: '',
        status: 'active',
        timeCreated: 1701444270,
        tfaEnabled: false,
        subscriptions: [
            {
                id: 80,
                subscriptionName: 'Envision Pulse - ',
                logoUrl: 'https://miracleadvance.com/wp-content/uploads/2023/09/pulse.svg'
            },
            {
                id: 75,
                subscriptionName: 'HRCT - modify ',
                logoUrl: 'https://miracleadvance.com/wp-content/uploads/2023/09/HRCT.svg'
            },
            {
                id: 81,
                subscriptionName: 'Envision Pulse - ',
                logoUrl: 'https://miracleadvance.com/wp-content/uploads/2023/09/pulse.svg'
            }
        ],
        demo: true
    },
    {
        id: 33333,
        role: 'customer',
        firstName: 'Kumar Bishojit',
        lastName: 'Paul',
        fullName: 'Kumar Bishojit Paul',
        organization: 'PPP',
        primaryPhone: '01717416667',
        primaryEmail: 'bishojit@gmail.com',
        photoUrl:
            'https://storage.googleapis.com/miracle-bucket-23/profile_images/WIN_20231207_15_55_12_Pro.jpg',
        primaryAddress: '',
        status: 'active',
        timeCreated: 1701444270,
        tfaEnabled: false,
        subscriptions: [
            {
                id: 74,
                subscriptionName: 'Envision NEXT - ABC',
                logoUrl: 'https://miracleadvance.com/wp-content/uploads/2023/09/envision-next-3.svg'
            },
            {
                id: 77,
                subscriptionName: 'Envision NEXT - OK',
                logoUrl: 'https://miracleadvance.com/wp-content/uploads/2023/09/envision-next-3.svg'
            },
            {
                id: 78,
                subscriptionName: 'Envision NEXT - ABC Hospital',
                logoUrl: 'https://miracleadvance.com/wp-content/uploads/2023/09/envision-next-3.svg'
            }
        ],
        demo: true
    }
];

export default null;
